<div>
  <ng-content select="[mensaje]"></ng-content>

  <textarea readonly>
    {{texto}}
   </textarea>
  <ng-content select="[footer]"></ng-content>
</div>
